/**
 * Dashboard 翻译 - 中文
 * Dashboard Translations - Chinese
 */
export const dashboardZh = {
  // 页面标题
  title: '工作台',
  subtitle: '欢迎回来',
  greeting: '你好，{name}！',
  welcome: '欢迎使用 FF AI Workspace 系统',
  
  // 统计卡片
  stats: {
    title: '数据概览',
    total: '总计',
    pending: '待处理',
    inProgress: '进行中',
    completed: '已完成',
    thisMonth: '本月',
    thisWeek: '本周',
    today: '今天',
    increase: '增长',
    decrease: '下降',
    
    // 具体指标
    totalApprovals: '待审批',
    totalTasks: '待办任务',
    totalNotifications: '未读通知',
    totalWorkRecords: '工作记录',
  },
  
  // 快捷操作
  quickActions: {
    title: '快捷操作',
    createApproval: '发起审批', // 保留旧的key以兼容
    createRequest: '新建申请',  // 新的key
    createWorkRecord: '提交工作记录',
    viewApprovals: '查看审批',
    viewTasks: '查看任务',
    viewNotifications: '查看通知',
    createExpense: '创建报销',
    submitLeave: '提交请假',
    viewOrganization: '组织架构',
  },
  
  // 最近活动
  recentActivity: {
    title: '最近活动',
    noActivity: '暂无活动记录',
    loadMore: '加载更多',
    viewAll: '查看全部',
    
    // 活动类型
    approvalCreated: '创建了审批',
    approvalApproved: '批准了审批',
    approvalRejected: '拒绝了审批',
    workRecordSubmitted: '提交了工作记录',
    taskCompleted: '完成了任务',
  },
  
  // 待办事项
  todos: {
    title: '待办事项',
    noTodos: '暂无待办事项',
    add: '添加待办',
    complete: '完成',
    delete: '删除',
    markComplete: '标记完成',
    markIncomplete: '标记未完成',
  },
  
  // 通知
  notifications: {
    title: '通知',
    noNotifications: '暂无通知',
    markAllRead: '全部标为已读',
    viewAll: '查看全部通知',
  },
  
  // 日期时间
  time: {
    morning: '早上好',
    afternoon: '下午好',
    evening: '晚上好',
    lastUpdated: '最后更新',
    refreshData: '刷新数据',
  },
};

export type DashboardTranslations = typeof dashboardZh;

